import Vue from 'vue'
import VueRouter from 'vue-router'
import OrderControl from "../views/OrderControl"
import OrderHome from "../views/OrderHome"
import OrderVerify from "../views/OrderVerify"
import OrderPro from "../views/OrderPro"
import CuttingCtaftWS from "../views/CuttingCtaftWS"
import SewCraftWS from "../views/SewCraftWS"
import VendorCraftWS from "../views/VendorCraftWS"
import EndHandleCraftWS from "../views/EndHandleCraftWS"
import OrderInStore from "../views/OrderInStore"
import OrderApply from "../views/OrderApply"
import OrderStereo from "../views/OrderStereo"
import OrderSetup from "../views/OrderSetup"
import ProRequirement from "../views/ProRequirement"
import GroupOrderFinance from "../views/GroupOrderFinance"
import GroupInfoFinance from "../views/GroupInfoFinance"
import FactoryInfoFinance from "../views/FactoryInfoFinance"

Vue.use(VueRouter)

const routes = [
    {
        path: '/order_platform',
        name: 'orders',
        component: OrderControl,
        meta: {
            title: '订单控制台'
        },
        children: [
            {
                // 订单控制台
                path: 'home',
                name: 'order_home',
                component: OrderHome,
                meta: {
                    title: '订单控制台'
                }

            },
            {
                // 审核控制台
                path: 'verify',
                name: 'order_verify',
                component: OrderVerify,
                meta: {
                    title: '审核控制台'
                }
            },
            {
                // 版房控制台
                path: 'stereo',
                name: 'order_stereo',
                component: OrderStereo,
                meta: {
                    title: '版房控制台'
                }
            },
            {
                // 采购控制台
                name: 'orderApply',
                path: 'apply',
                component: OrderApply,
                meta: {
                    title: '采购控制台'
                }
            },
            {
                // 生产控制台
                path: 'pro',
                name: 'orderPro',
                component: OrderPro,
                meta: {
                    title: '生产控制台'
                }
            },

            {
                // 裁床控制台
                name: 'cuttingWorkSpace',
                path: 'cuttingWorkSpace',
                component: CuttingCtaftWS,
                meta: {
                    title: '裁床控制台'
                }

            },

            {
                // 缝纫工艺控制台
                name: 'sewWorkSpace',
                path: 'sewWorkSpace',
                component: SewCraftWS,
                meta: {
                    title: '缝纫控制台'
                }
            },
            {
                // 外协工艺控制台
                name: 'vendorWorkSpace',
                path: 'vendorWorkSpace',
                component: VendorCraftWS,
                meta: {
                    title: '外协控制台'
                }
            },
            {
                // 后道工艺控制台
                name: 'endHandleWorkSpace',
                path: 'endHandleWorkSpace',
                component: EndHandleCraftWS,
                meta: {
                    title: '后道控制台'
                }
            },

            {
                // 入库控制台
                name: 'orderInStore',
                path: 'orderInStore',
                component: OrderInStore,
                meta: {
                    title: '入库控制台'
                }
            },
            {
                // 小组分派单
                name: 'groupOrderFinance',
                path: 'groupOrderFinance',
                component: GroupOrderFinance,
                meta: {
                    title: '小组分派单'
                }
            },
            {
                // 小组结算信息
                name: 'groupInfoFinance',
                path: 'groupInfoFinance',
                component: GroupInfoFinance,
                meta: {
                    title: '小组结算'
                }
            },
            {
                // 工厂结算信息
                name: 'factoryInfoFinance',
                path: 'factoryInfoFinance',
                component: FactoryInfoFinance,
                meta: {
                    title: '工厂结算'
                }
            },
            {
                // 配置信息
                name: 'orderSetup',
                path: 'orderSetup',
                component: OrderSetup,
                meta: {
                    title: '配置信息',
                },
            },
             {
                // 开发需求管理
                name: 'proRequirement',
                path: 'proRequirement',
                component: ProRequirement,
                meta: {
                    title: '开发需求管理'
                }
            }
        ]
    },
    {
        path: '/document',
        name: 'Document',
        component: () => import('../views/UseDocument'),
        children: [
            {
                name: 'mdfCraftDoc',
                path: 'mdf_craft',
                component: () => import('../components/documents/MdfCraft')
            },
        ]
    }
]



const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.afterEach((to, from) => {
    document.title = to.meta.title
})

export default router
